import { QueryKeys } from "@cede/utils";
import type { QueryClient } from "@tanstack/react-query";

export function invalidateUserStats(queryClient: QueryClient): Promise<void> {
  return queryClient.invalidateQueries({ queryKey: [QueryKeys.USER_STATS] });
}
